import React, { createContext, useState } from 'react';

export const ArtCtx = createContext();

export function ArtProvider({ children }) {
  const [slots, setSlots] = useState({});        // { slot1: artObj, … }
  const [cart, setCart]   = useState({});        // { variantId: qty }

  const setSlot = (slotId, art) =>
    setSlots((s) => ({ ...s, [slotId]: art }));

  const addToCart = (variantId) =>
    setCart((c) => ({ ...c, [variantId]: (c[variantId] || 0) + 1 }));

  return (
    <ArtCtx.Provider value={{ slots, setSlot, cart, addToCart }}>
      {children}
    </ArtCtx.Provider>
  );
}
